import React from 'react';

import './Modal.scss';

const Modal = props => {

  let paddingStyle = {};
  if (props.paddingStyle) {
    paddingStyle = { 'padding': props.paddingStyle + 'px' }
  }
  if (props.size) {
    paddingStyle['maxWidth'] = props.size + 'px'
  }
  let classes = ["modal-wrapper","modal-dash"];
  if (props.type) {
    classes.push('withShadow')
  }
  if (props.customClass) {
    classes.push(props.customClass)
  }

  return (
    <div className="modal">
      <div className={classes.join(" ")} style={paddingStyle}>
        {props.close && <div className="modal-close" id="modal-close" onClick={props.close}></div>}
        <div className="modal-content">{props.children}</div>
      </div>
    </div>
  );
};

export default Modal;
